import React, {Component} from 'react';

import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import cView from './cView';

export default class i14v extends cView {

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stss = { // 親を上書き
  sdld_c14rDtlsss: {c14r:[]},
};

static op_loadDtl = pd => 
  (pd.elm == 'i14r') ?
    super.op_loadDtl({
      ...pd,
      elm: 'i14r',
      o_cnd: _dd_datss => {
        let _cnd = cf.c('i14r', `_fst = ${global.t?.state.sgcd_cmnStgs.c20r_fst}`)
        return _cnd;
      },
    })
  : super.op_loadDtl(pd)


$clp_loadLists = () => [ // 親を上書き
  cf.myRN_savePageStgs({
    sgc_pnlMode: 'dtl',
  }),
  i14v.op_loadDtl({
    elm: 'i14r',
  }),
];

$clp_loadDtls = () => [
  global.t?.op_loadListAll(),
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_i14rDtlsss',
    dd_elmDefss: {
      i14r: {
        elm: 'i14r',
        b_setPageKey: true,
        b_vsn: true,
        od_insDats: _dd_datss => {
          let _d = {
            i14ri11i: _dd_datss.i14r.d_flds.i14ri11i ?? '',
            i14ri12i: _dd_datss.i14r.d_flds.i14ri12i ?? '',
            i14ri21i: _dd_datss.i14r.d_flds.i14ri21i ?? '',
            i14ri31i: _dd_datss.i14r.d_flds.i14ri31i ?? '',
            i14ri42i: _dd_datss.i14r.d_flds.i14ri42i ?? '',
            i14ri52i: _dd_datss.i14r.d_flds.i14ri52i ?? '',
            i14ri61i: _dd_datss.i14r.d_flds.i14ri61i ?? '',
            i14ri62i: _dd_datss.i14r.d_flds.i14ri62i ?? '',
          };
          return _d;
        },
      },
    },
  }),
];

render() {
  return (
    ce.c(ce.RootDtl, {
      key: -1,
      d_hdrs: {
        d_subs: 
          ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
            {
              iconName: 'users',
              pfx: 'ユーザ切替',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: 'c00v2a',
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            }
          : null,
      },
      d_bdys: {
        l_clds: [

          ce.c(ce.Pnl, {
            key: -1,
            mode: 'dtl',
            b_vsb: true,
            d_hdrs: {
            },
            d_btms: {
              l_clds: [
                ce.c(ce.Box, {
                  key: -1,
                  stlCta: {
                    height: (ic.g_dvcMode == 's') ? ic.s(2) : ic.s(2 * 2),
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    width: global.t?.state.sgcd_dmns.n_bdyW,
                    marginTop: ic.m(1),
                    marginBottom: ic.m(1),
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }
                }, [
                  ce.c(ce.Btn, {
                    key: -4,
                    pfx: '変更',
                    b_vsb: global.t?.state.sgc_pageMode == 'show' ? true : false,
                    stlBtn: {
                      width: ic.s(8),
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        mode: 'sttEdit',
                      });
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -5,
                    pfx: 'キャンセル',
                    b_vsb: global.t?.state.sgc_pageMode == 'edit' ? true : false,
                    stlBtn: {
                      width: ic.s(8),
                      backgroundColor: ic.g_fontCcdSml,
                      borderColor: ic.g_fontCcdSml,
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        mode: 'cclEdit',
                      });
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -6,
                    pfx: '登録',
                    b_vsb: global.t?.state.sgc_pageMode == 'edit' ? true : false,
                    stlBtn: {
                      width: ic.s(8),
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        mode: 'endEdit',
                      });
                    },
                  }),
                ])

              ],
            },
            d_bdys: {
              l_clds: [
                ce.c(cr.InpTree, {
                  key: -12,
                  state: 'sdld_i14rDtlsss',
                  dd_elmDefss: {
                    i14r: {
                      elm: 'i14r',
                      pfx: '設定',
                      b_row: true,
                      b_ttl: false,
                      dd_fldDefss: cf.myRN_getFldDefs([
                        cf.f('i14ri11i', {
                        }),
                        cf.f('i14ri21i', {
                        }),
                        cf.f('i14ri31i', {
                        }),
                        cf.f('i14ri61i', {
                        }),
                        cf.f('i14ri12i', {
                        }),
                        cf.f('i14ri42i', {
                        }),
                        cf.f('i14ri52i', {
                        }),
                        cf.f('i14ri62i', {
                        }),
                        cf.f('i14ri71s', {
                          b_mln: true,
                          stlInp: {
                            height: ic.s(2.2 * 3)
                          }
                        }),
                        cf.f('i14ri81s', {
                          b_mln: true,
                          stlInp: {
                            height: ic.s(2.2 * 3)
                          }
                        }),
                        cf.f('i14ri72s', {
                          b_mln: true,
                          stlInp: {
                            height: ic.s(2.2 * 3)
                          }
                        }),
                        cf.f('i14ri82s', {
                          b_mln: true,
                          stlInp: {
                            height: ic.s(2.2 * 3)
                          }
                        }),
                        cf.f('i14ri73s', {
                          b_mln: true,
                          stlInp: {
                            height: ic.s(2.2 * 3)
                          }
                        }),
                        cf.f('i14ri91s', {
                          b_mln: true,
                          stlInp: {
                            height: ic.s(2.2 * 3)
                          }
                        }),
                        cf.f('i14ri92s', {
                        }),
                        cf.f('i14ria1s', {
                          b_mln: true,
                          stlInp: {
                            height: ic.s(2.2 * 3)
                          }
                        }),
                        cf.f('i14ria2s', {
                        }),
                        cf.f('i14rib1s', {
                          b_mln: true,
                          stlInp: {
                            height: ic.s(2.2 * 2)
                          }
                        }),
                        cf.f('i14rib2s', {
                        }),
                      ]),
                      d_cmns: {
                        n_cnt: 1,
                        b_hzl: false,
                        n_hdrW: ic.s(12),
                        n_bdyW: ic.s(40),
//                        n_h: ic.s(4),
                      },
                    },
                  },
                }),
              ],
            },
          }),

        ],
      }
    })
  );
}

}
